import http from "../../http-common";

class EventDetailsService {
    getEventDetails(path: string) {
        return http.get(`events/${path}`);
    }
}

export default new EventDetailsService();
